<template>
  <a :href="targetUrl" class="widget">
    <div class="widget__title">{{ $res.Views.StartsSoonWidget_Title }}</div>
    <div class="widget__body">
      <div class="widget__count"
           :class="{ 'widget__count_small': total > 99 }">
        {{ total }}
      </div>
      <div class="widget__content">
        <div class="widget__content-inner">
          <div v-if="todayCount">{{ $res.Views.StartsSoonWidget_Today }} {{ todayCount }}</div >
          <div v-if="tomorrowCount">{{ $res.Views.StartsSoonWidget_Tomorrow }} {{ tomorrowCount }}</div>
          <div v-if="afterTomorrowCount">{{ $res.Views.StartsSoonWidget_AfterTomorrow }} {{ afterTomorrowCount }}</div>
        </div>
        <div class="widget__icon">
          <svg width="36" height="36" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75221 6.49563C3.75221 6.49563 12.5074 2.36189 13.1327 2.05189C14.2792 1.48357 15.7384 1.84524 15.9469 2.46526C16.1553 3.08528 15.7384 3.49869 14.9046 4.0154C14.0708 4.53212 11.7778 5.4622 11.7778 5.4622L9.48475 11.7661L9.17206 12.3862L7.92132 13.0062L7.8171 12.7995L8.33824 7.11569L6.77482 7.83909C6.77482 7.83909 5.94099 8.14915 4.4818 8.45914C3.02261 8.76913 2.57337 8.53906 2.50147 8.45914L0 5.87557L0.729596 5.56555L3.75221 6.49563Z" fill="currentColor"/>
            <path d="M8.54673 3.49872L6.14949 4.63549L3.64802 3.08535C3.43403 2.94158 3.4517 2.87564 3.64802 2.77532L4.58607 2.2586C4.75677 2.19069 4.86857 2.18646 5.10721 2.2586L8.54673 3.49872Z" fill="currentColor"/>
            <path d="M1.00001 14.1C0.50295 14.1 0.100006 14.5029 0.100006 15C0.100006 15.4971 0.50295 15.9 1.00001 15.9H15C15.4971 15.9 15.9 15.4971 15.9 15C15.9 14.5029 15.4971 14.1 15 14.1H1.00001Z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    today: Object,
    tomorrow: Object,
    afterTomorrow: Object
  },
  data() {
    return {};
  },
  computed: {
    todayCount() {
      if (this.today) {
        return this.today.Count;
      }

      return 0;
    },
    tomorrowCount() {
      if (this.tomorrow) {
        return this.tomorrow.Count;
      }

      return 0;
    },
    afterTomorrowCount() {
      if (this.afterTomorrow) {
        return this.afterTomorrow.Count;
      }

      return 0;
    },
    total() {
      return this.afterTomorrowCount + this.tomorrowCount + this.todayCount;
    },
    targetUrl() {
      if (this.tomorrow) {
        return this.tomorrow.TargetUrl
      }
      
      if (this.afterTomorrow) {
        return this.afterTomorrow.TargetUrl;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@use "./widget";
</style>


